import React from 'react'
import { Text, Skeleton, Flex  } from '@chakra-ui/react'

interface ITitleResumeProps {
  isLoadingScreen: boolean
}

// Leyenda al Pie Subscription Resume
const FooterLabel = ({ isLoadingScreen }: ITitleResumeProps) => (
  <Skeleton isLoaded={!isLoadingScreen}>
    <Flex
      data-testid='footerLabel'
      justifyContent='center'
      alignItems='center'
      bgColor='neutral.95'
      borderRadius={8}
      p='12px 16px'
    >
      <Text data-testid='footerLabel-text' textStyle='labelMd' color='secondary.900' textAlign='center' justifyContent='center'>
        Tené en cuenta que podrás utilizar los servicios solicitados si el banco con el que operás los tiene habilitados
      </Text>
    </Flex>
  </Skeleton>
)

export default FooterLabel